import React from 'react'
import "./style.scss"

const Footer = () => {
  return (
    <div className='acg-footer'>
        <span className='ft-item'><a href='https://alphacapitalgroup.uk/privacy-notice/' target='_blank' rel='noreferrer'>Privacy Policy</a></span>
        <span className='ft-item'><a href='https://alphacapitalgroup.uk/terms-of-use-for-website/' target='_blank' rel='noreferrer'>Terms</a></span>
        <span className='ft-item'><a href='https://alphacapitalgroup.uk/disclaimer/' target='_blank' rel='noreferrer'>Disclaimer</a></span>
        <span className='ft-item'><a href='https://alphacapitalgroup.uk/return-policy/' target='_blank' rel='noreferrer'>Return Policy</a></span>
    </div>
  )
}

export default Footer
